import { PROVIDENT_FUND_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getFundListLoading: false,
    getFundListSuccess: false,
    getFundListFailure: false,
    getFundListError: null,
    fundList: [],
    addFundListLoading: false,
    addFundListSuccess: false,
    addFundListFailure: false,
    addFundListError: null,
    editFundListLoading: false,
    editFundListSuccess: false,
    editFundListFailure: false,
    editFundListError: null,
    deleteFundListLoading: false,
    deleteFundListSuccess: false,
    deleteFundListFailure: false,
    deleteFundListError: null,
}

export const fundReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_REQUEST:
            return {
                ...state,
                getFundListLoading: true,
                getFundListSuccess: false,
                getFundListFailure: false,
                getFundListError: null
            }
        case PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_SUCCESS:
            return {
                ...state,
                getFundListLoading: false,
                getFundListSuccess: true,
                getFundListFailure: false,
                getFundListError: null,
                fundList: action.payload
            }
        case PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_FAILURE:
            return {
                ...state,
                getFundListLoading: false,
                getFundListSuccess: false,
                getFundListFailure: true,
                getFundListError: action.payload
            }
        case PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_REQUEST:
            return {
                ...state,
                addFundListLoading: true,
                addFundListSuccess: false,
                addFundListFailure: false,
                addFundListError: null,
            }
        case PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_SUCCESS:
            let newFundsList = state.fundList
            var data = {
                id: newFundsList.length,
                employeeName: action.payload.employeeName,
                providentFundType: action.payload.providentFundType,
                employeeShare: action.payload.employeeShare,
                companyShare: action.payload.companyShare,
                startedDate: action.payload.startedDate,
                employeePercent: action.payload.employeePercent,
                companyPercent: action.payload.companyPercent,
                status: action.payload.status
            }
            newFundsList.push(data)
            return {
                ...state,
                addFundListLoading: false,
                addFundListSuccess: true,
                addFundListFailure: false,
                addFundListError: null,
                fundList: newFundsList
            }
        case PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_FAILURE:
            return {
                ...state,
                addFundListLoading: false,
                addFundListSuccess: true,
                addFundListFailure: false,
                addFundListError: action.payload,
            }
        case PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_REQUEST:
            return {
                ...state,
                editFundListLoading: true,
                editFundListSuccess: false,
                editFundListFailure: false,
                editFundListError: null,
            }
        case PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_SUCCESS:
            let fund_Lists = state.fundList
            var data = {
                id: action.payload.id,
                employeeName: action.payload.employeeName,
                providentFundType: action.payload.providentFundType,
                employeeShare: action.payload.employeeShare,
                companyShare: action.payload.companyShare,
                startedDate: action.payload.startedDate,
                employeePercent: action.payload.employeePercent,
                companyPercent: action.payload.companyPercent,
                status: action.payload.status
            }
            for (var i = 0; i < fund_Lists.length; i++) {
                if (fund_Lists[i].id === action.payload.id) {
                    fund_Lists[i] = action.payload
                }
            }
            return {
                ...state,
                editFundListLoading: false,
                editFundListSuccess: true,
                editFundListFailure: false,
                editFundListError: null,
                fundList: fund_Lists

            }
        case PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_FAILURE:
            return {
                ...state,
                editFundListLoading: false,
                editFundListSuccess: true,
                editFundListFailure: false,
                editFundListError: action.payload,
            }
        case PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_REQUEST:
            return {
                ...state,
                deleteFundListLoading: true,
                deleteFundListSuccess: false,
                deleteFundListFailure: false,
                deleteFundListError: null,
            }
        case PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_SUCCESS:
            let fundsLists = state.fundList
            for (var i = 0; i < fundsLists.length; i++) {
                if (fundsLists[i].id === action.payload) {
                    fundsLists.splice(i, 1)
                }
            }
            return {
                ...state,
                deleteFundListLoading: false,
                deleteFundListSuccess: true,
                deleteFundListFailure: false,
                deleteFundListError: null,
                fundList: fundsLists
            }
        case PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_FAILURE:
            return {
                ...state,
                deleteFundListLoading: false,
                deleteFundListSuccess: true,
                deleteFundListFailure: false,
                deleteFundListError: action.payload,
            }
        default:
            return state
    }
}